import React from 'react'
import PropTypes from 'prop-types'
import HRule from '../../atoms/HRule'

import { GoogleIconButton } from '../../atoms/GoogleIconButton'
import { FacebookIconButton } from '../../atoms/FacebookIconButton'
import { isLoginScrollEnabled } from '../../../util/experiments'

const OauthLoginCallout = props => {
  const {
    facebookAppId,
    onCancel,
    onError,
    onRequireEmail,
    onSubmit,
    onUserLoggedIn,
    lurker,
    tracker,
    onFacebookLoginCallback,
    hideDivider = false,
    onPhoneNotValidatedError,
    onChallengePinCodeCall,
    abTests,
    sessionTokens,
    onAccountNotValidated,
    onAccountMustValidate,
    modalMode,
    onAccountSocialLoginTyping,
    onAccountCompleteData,
  } = props

  const experimentOn = isLoginScrollEnabled(abTests)

  const onFacebookSubmit = () => {
    if (typeof onFacebookLoginCallback === 'function') {
      onFacebookLoginCallback()
    }
    if (typeof onSubmit === 'function') {
      onSubmit()
    }
  }

  return (
    <div className="flex flex-col mt-2">
      <div
        className="flex justify-center"
        style={{ gap: experimentOn ? 'var(--spacing-3)' : undefined }}
      >
        <GoogleIconButton
          onCancel={onCancel}
          onError={onError}
          onSubmit={onSubmit}
          onUserLoggedIn={onUserLoggedIn}
          lurker={lurker}
          tracker={tracker}
          onPhoneNotValidatedError={onPhoneNotValidatedError}
          onChallengePinCodeCall={onChallengePinCodeCall}
          sessionTokens={sessionTokens}
          onAccountNotValidated={onAccountNotValidated}
          onAccountMustValidate={onAccountMustValidate}
          abTests={abTests}
          modalMode={modalMode}
          onAccountSocialLoginTyping={onAccountSocialLoginTyping}
          onAccountCompleteData={onAccountCompleteData}
        />
        <FacebookIconButton
          marginLeft={!experimentOn ? '--spacing-4' : undefined}
          facebookAppId={facebookAppId}
          onCancel={onCancel}
          onError={onError}
          onRequireEmail={onRequireEmail}
          onSubmit={onFacebookSubmit}
          onUserLoggedIn={onUserLoggedIn}
          lurker={lurker}
          tracker={tracker}
          onPhoneNotValidatedError={onPhoneNotValidatedError}
          onChallengePinCodeCall={onChallengePinCodeCall}
          sessionTokens={sessionTokens}
          onAccountNotValidated={onAccountNotValidated}
          onAccountMustValidate={onAccountMustValidate}
          abTests={abTests}
          modalMode={modalMode}
          onAccountSocialLoginTyping={onAccountSocialLoginTyping}
          onAccountCompleteData={onAccountCompleteData}
        />
      </div>
      {!hideDivider && (
        <div className="flex mb-2 mt-4">
          <HRule text="Ou conecte com" />
        </div>
      )}
    </div>
  )
}

OauthLoginCallout.defaultProps = {
  facebookButtonText: 'Entrar com o Facebook',
  googleButtonText: 'Entrar com o Google',
  magiclinkButtonText: 'Entrar sem senha',
}

OauthLoginCallout.propTypes = {
  facebookAppId: PropTypes.string,
  magiclinkButtonText: PropTypes.string,
  hideDivider: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onRequireEmail: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onUserLoggedIn: PropTypes.func.isRequired,
  lurker: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  tracker: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onMagicLinkClick: PropTypes.func,
  onFacebookLoginCallback: PropTypes.func,
  onPhoneNotValidatedError: PropTypes.func,
  onChallengePinCodeCall: PropTypes.func,
  abTests: PropTypes.string,
  sessionTokens: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onAccountNotValidated: PropTypes.func,
  onAccountMustValidate: PropTypes.func,
  modalMode: PropTypes.bool,
  onAccountSocialLoginTyping: PropTypes.func,
  onAccountCompleteData: PropTypes.func,
}

export { OauthLoginCallout }
